var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'switcher',
    {
      switcher_active: _vm.isActive,
    } ],on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('div',{class:[
      'switcher-ball',
      {
        'switcher-ball_active': _vm.isActive,
      } ]})])}
var staticRenderFns = []

export { render, staticRenderFns }